/* ==========================================================================
   Kleos — Lightbox de galería (snippets/iurop-lightbox.liquid)
   --------------------------------------------------------------------------
   API global: window.iuropLightbox = { open(mediaId), close() }.
   · open(mediaId): añade is-open + aria-hidden=false + html.iurop-lb-locked y
     scrollea (behavior 'auto') al slide cuyo data-media-id coincide. Los ids
     superan 2^31 → SIEMPRE comparar como String, nunca parseInt / |0.
     Sin id o no encontrado → slide 0.
   · close(): quita clases y devuelve el foco al opener.
   · Cierres: X [data-lb-close], click en backdrop [data-lb-backdrop] (o en la
     zona negra del slide: el <img> se dimensiona a su contenido en CSS, así
     que todo el letterbox ES el slide y dispara este cierre), Esc.
   · RED: las <img> llegan con data-src/data-srcset (sin src) → hydrate() les
     pone src/srcset en el primer open(). Idempotente por-DOM (la query
     img[data-src] queda vacía tras hidratar) → sin flag global, sobrevive al
     re-render del editor. Evita descargar la galería a 800-1600w en cada
     vista de PDP con el lightbox cerrado.
   · Teclado en fase CAPTURA + stopPropagation de las teclas consumidas con
     el lightbox abierto: es el overlay superior (z 300) y se traga el Esc →
     el listener burbuja del cart-drawer (iurop-cart.js) NO cierra a la vez.
   · Navegación: flechas (solo ≥990px; regla de agencia: ocultas en extremos
     con .is-hidden), teclado ←/→, swipe táctil nativo (scroll-snap del track)
     y miniaturas [data-lb-thumb].
   · Sync de flechas/miniatura activa con listener scroll SÍNCRONO:
     index = round(scrollLeft / clientWidth). Sin rAF (se estrangula en 2º
     plano y congelaría el estado).
   · Focus trap básico (Tab cicla dentro del diálogo).
   Clicks y teclado delegados en document → sobreviven al re-render del editor.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__iuropLightboxInit) return;
  window.__iuropLightboxInit = true;

  var root = null;
  var track = null;
  var slides = [];
  var thumbs = [];
  var prevBtn = null;
  var nextBtn = null;
  var closeBtn = null;
  var opener = null;
  var currentIndex = 0;

  function grab() {
    root = document.getElementById('IuropLightbox');
    if (!root) return false;
    track = root.querySelector('[data-lb-track]');
    slides = Array.prototype.slice.call(root.querySelectorAll('[data-lb-slide]'));
    thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-lb-thumb]'));
    prevBtn = root.querySelector('[data-lb-prev]');
    nextBtn = root.querySelector('[data-lb-next]');
    closeBtn = root.querySelector('[data-lb-close]');
    bindTrack();
    return true;
  }

  /* Re-localiza el DOM si el editor re-renderizó la sección. */
  function ensure() {
    if (root && document.body.contains(root)) return true;
    return grab();
  }

  function isOpen() {
    return !!(root && root.classList.contains('is-open'));
  }

  function reducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function syncArrows(index) {
    /* Regla de agencia: en el inicio solo se ve la derecha; al llegar al
       final desaparece la derecha (mostrar/ocultar, no disabled gris). */
    if (prevBtn) prevBtn.classList.toggle('is-hidden', index <= 0);
    if (nextBtn) nextBtn.classList.toggle('is-hidden', index >= slides.length - 1);
  }

  function setActive(index) {
    var slide = slides[index];
    var mid = slide ? String(slide.getAttribute('data-media-id')) : '';
    thumbs.forEach(function (t) {
      t.classList.toggle('is-active', String(t.getAttribute('data-media-id')) === mid);
    });
    syncArrows(index);
  }

  function goTo(index, behavior) {
    if (!track || !slides.length) return;
    index = Math.max(0, Math.min(index, slides.length - 1));
    var slide = slides[index];
    if (!slide) return;
    var b = behavior || 'smooth';
    /* En pestaña OCULTA las animaciones de scroll (smooth nativo y rAF) se
       CONGELAN → salto directo por asignación. Cubre además la verificación
       en 2º plano, que con smooth daría el falso negativo "no se mueve". */
    if (reducedMotion() || document.hidden) b = 'auto';
    if (b === 'auto') track.scrollLeft = slide.offsetLeft;
    else track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
    currentIndex = index;
    setActive(index);
  }

  function hydrate() {
    if (!root) return;
    var imgs = root.querySelectorAll('img[data-src]');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      var srcset = img.getAttribute('data-srcset');
      /* srcset ANTES que src: si src entra primero el navegador puede
         disparar la descarga del fallback 1600w y luego la del candidato. */
      if (srcset) { img.setAttribute('srcset', srcset); img.removeAttribute('data-srcset'); }
      img.setAttribute('src', img.getAttribute('data-src'));
      img.removeAttribute('data-src');
    }
  }

  function indexOfMedia(mediaId) {
    if (mediaId == null || mediaId === '') return 0;
    var idStr = String(mediaId);
    for (var i = 0; i < slides.length; i++) {
      if (String(slides[i].getAttribute('data-media-id')) === idStr) return i;
    }
    return 0;
  }

  function bindTrack() {
    if (!track || track.__iuropLbBound) return;
    track.__iuropLbBound = true;
    /* Síncrono en el propio evento (una lectura barata por scroll). */
    track.addEventListener('scroll', function () {
      if (!track.clientWidth) return;
      var index = Math.round(track.scrollLeft / track.clientWidth);
      index = Math.max(0, Math.min(index, slides.length - 1));
      currentIndex = index;
      setActive(index);
    }, { passive: true });
  }

  function open(mediaId) {
    if (!ensure()) return;
    hydrate();
    opener = document.activeElement;
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('iurop-lb-locked');
    goTo(indexOfMedia(mediaId), 'auto');
    if (closeBtn) closeBtn.focus();
  }

  function close() {
    if (!ensure()) return;
    root.classList.remove('is-open');
    document.documentElement.classList.remove('iurop-lb-locked');
    /* Devolver el foco ANTES de aria-hidden=true: si no, el foco quedaría
       dentro de un subárbol oculto y el navegador lo bloquea/avisa. */
    if (opener && typeof opener.focus === 'function' && document.body.contains(opener)) {
      try { opener.focus(); } catch (e) { /* noop */ }
    }
    opener = null;
    root.setAttribute('aria-hidden', 'true');
  }

  function trapFocus(event) {
    var focusables = Array.prototype.slice.call(
      root.querySelectorAll('button, [href], [tabindex]:not([tabindex="-1"])')
    ).filter(function (el) {
      /* Fuera los display:none (flechas en móvil o en los extremos). Dentro
         del lightbox (fixed) offsetParent solo es null con display:none. */
      return el.offsetParent !== null;
    });
    if (!focusables.length) return;
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    if (!root.contains(document.activeElement)) {
      event.preventDefault();
      first.focus();
    } else if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  /* ---- Cierres y navegación por click (delegado en document) ---- */
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    if (target.closest('[data-lb-close]')) { close(); return; }
    if (!isOpen()) return;
    if (target.closest('[data-lb-prev]')) { goTo(currentIndex - 1); return; }
    if (target.closest('[data-lb-next]')) { goTo(currentIndex + 1); return; }
    var thumb = target.closest('[data-lb-thumb]');
    if (thumb) { goTo(indexOfMedia(thumb.getAttribute('data-media-id'))); return; }
    if (target.closest('[data-lb-backdrop]')) { close(); return; }
    /* Click en la zona vacía del slide (padding alrededor de la imagen):
       visualmente es el backdrop → también cierra. */
    var slide = target.closest('[data-lb-slide]');
    if (slide && target === slide) close();
  });

  /* ---- Teclado: Esc cierra, ←/→ navegan, Tab cicla dentro ----
     CAPTURA en document (corre antes que los listeners burbuja) +
     stopPropagation de las teclas consumidas: con el lightbox abierto es el
     overlay superior y se traga el input → un solo Esc NO cierra además el
     cart-drawer (su listener burbuja en iurop-cart.js no llega a ejecutarse). */
  document.addEventListener('keydown', function (event) {
    if (!isOpen()) return;
    if (event.key === 'Escape' || event.key === 'Esc') {
      event.preventDefault();
      event.stopPropagation();
      close();
    } else if (event.key === 'ArrowLeft') {
      event.preventDefault();
      event.stopPropagation();
      goTo(currentIndex - 1);
    } else if (event.key === 'ArrowRight') {
      event.preventDefault();
      event.stopPropagation();
      goTo(currentIndex + 1);
    } else if (event.key === 'Tab') {
      event.stopPropagation();
      trapFocus(event);
    }
  }, true);

  window.iuropLightbox = { open: open, close: close };

  function boot() {
    if (grab()) syncArrows(currentIndex);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
